<template>
  <base-dialog-component
    :showClose="true"
    :open="open"
    :title="$t('testSelectionTitle')"
    optionType="test"
    :options="testsFiltered"
    @selectOption="selectTest"
    @closeDialog="closeDialog"
    height="auto"
    width="70vw"
    maxWidth="900px"
    top="50%"
    left="50%"
    :center="true"
    :overlay="true"
  ></base-dialog-component>
</template>
<script>
import baseComponent from "./baseComponent.vue";

export default {
  name: "TestSelectionComponent",
  components: {
    baseDialogComponent: baseComponent,
  },
  data() {
    return {
      open: false,
      resolveDialog: null,
      productName: null,
      testsFiltered: [],
      test: {
        Chill_Lab: [
          {
            title: "testSelectionTitlePerformance",
            body: "testSelectionBodyPerformance",
            key: "performance",
          },
          {
            title: "testSelectionTitleNoise",
            body: "testSelectionBodyNoise",
            key: "noise",
          },
          {
            title: "testSelectionTitleAdiabatic",
            body: "testSelectionBodyAdiabatic",
            key: "adiabatic",
          },
          {
            title: "testSelectionTitleFast",
            body: `testSelectionBodyFastChill_Lab`,
            key: "fast",
          },
          {
            title: "testSelectionTitleTransient",
            body: "testSelectionBodyTransient",
            key: "transient",
          },
          {
            title: "testSelectionTitleSoftware",
            body: "testSelectionBodySoftware",
            key: "software",
            noTest: true,
          },
        ],
        Indoor_Lab: [
          {
            title: "testSelectionTitlePerformance",
            body: "testSelectionBodyPerformance",
            key: "performance",
          },
          {
            title: "testSelectionTitleFast",
            body: `testSelectionBodyFastIndoor_Lab`,
            key: "fast",
          },
          {
            title: "testSelectionTitleSoftware",
            body: "testSelectionBodySoftware",
            key: "software",
            noTest: true,
          },
        ],
      },
    };
  },
  computed: {
    lab() {
      return this.$store.getters.getCurrentLab;
    },
    testsLab() {
      return this.test[this.lab];
    },
  },
  beforeMount() {
    this.$root.$on("openTestSelection", this.openTestSelection);
  },
  beforeDestroy() {
    this.$root.$off("openTestSelection", this.openTestSelection);
  },
  methods: {
    openTestSelection({ resolve, productName }) {
      this.resolveDialog = resolve;
      this.productName = productName;
      if (productName !== "AFC_AD") {
        this.testsFiltered = this.testsLab.filter(
          (test) => test.key !== "adiabatic"
        );
      } else {
        this.testsFiltered = this.testsLab;
      }
      this.open = true;
    },
    selectTest({ option }) {
      this.resolveDialog(option);
      this.open = false;
    },
    closeDialog() {
      this.resolveDialog(false);
      this.open = false;
    },
  },
};
</script>
<style lang="scss" scoped></style>
